import * as React from 'react'

const BankIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M21 11.751H3C2.04 11.751 1.251 10.96 1.251 10V6.68C1.251 6 1.72 5.311 2.349 5.06L11.349 1.46C11.729 1.311 12.271 1.311 12.651 1.46L21.649 5.06C22.28 5.311 22.751 6.011 22.751 6.68V10C22.751 10.96 21.96 11.751 21 11.751ZM12 2.84C11.96 2.84 11.92 2.84 11.9 2.851L2.909 6.451C2.849 6.48 2.751 6.611 2.751 6.68V10C2.751 10.14 2.86 10.251 3 10.251H21C21.14 10.251 21.251 10.14 21.251 10V6.68C21.251 6.611 21.16 6.48 21.089 6.451L12.089 2.851C12.071 2.84 12.04 2.84 12 2.84Z"
      fill={props.fill}
    />
    <path
      d="M22 22.751H2C1.591 22.751 1.251 22.411 1.251 22V19C1.251 18.04 2.04 17.251 3 17.251H21C21.96 17.251 22.751 18.04 22.751 19V22C22.751 22.411 22.411 22.751 22 22.751ZM2.751 21.251H21.251V19C21.251 18.86 21.14 18.751 21 18.751H3C2.86 18.751 2.751 18.86 2.751 19V21.251Z"
      fill={props.fill}
    />
    <path
      d="M4 18.751C3.589 18.751 3.251 18.411 3.251 18V11C3.251 10.589 3.589 10.251 4 10.251C4.411 10.251 4.751 10.589 4.751 11V18C4.751 18.411 4.411 18.751 4 18.751Z"
      fill={props.fill}
    />
    <path
      d="M8 18.751C7.589 18.751 7.251 18.411 7.251 18V11C7.251 10.589 7.589 10.251 8 10.251C8.411 10.251 8.751 10.589 8.751 11V18C8.751 18.411 8.411 18.751 8 18.751Z"
      fill={props.fill}
    />
    <path
      d="M12 18.751C11.589 18.751 11.251 18.411 11.251 18V11C11.251 10.589 11.589 10.251 12 10.251C12.411 10.251 12.751 10.589 12.751 11V18C12.751 18.411 12.411 18.751 12 18.751Z"
      fill={props.fill}
    />
    <path
      d="M16 18.751C15.589 18.751 15.251 18.411 15.251 18V11C15.251 10.589 15.589 10.251 16 10.251C16.411 10.251 16.751 10.589 16.751 11V18C16.751 18.411 16.411 18.751 16 18.751Z"
      fill={props.fill}
    />
    <path
      d="M20 18.751C19.589 18.751 19.251 18.411 19.251 18V11C19.251 10.589 19.589 10.251 20 10.251C20.411 10.251 20.751 10.589 20.751 11V18C20.751 18.411 20.411 18.751 20 18.751Z"
      fill={props.fill}
    />
    <path
      d="M23 22.751H1C0.591 22.751 0.251 22.411 0.251 22C0.251 21.589 0.591 21.251 1 21.251H23C23.411 21.251 23.751 21.589 23.751 22C23.751 22.411 23.411 22.751 23 22.751Z"
      fill={props.fill}
    />
    <path
      d="M12 9.251C10.76 9.251 9.751 8.24 9.751 7C9.751 5.76 10.76 4.751 12 4.751C13.24 4.751 14.251 5.76 14.251 7C14.251 8.24 13.24 9.251 12 9.251ZM12 6.251C11.589 6.251 11.251 6.589 11.251 7C11.251 7.411 11.589 7.751 12 7.751C12.411 7.751 12.751 7.411 12.751 7C12.751 6.589 12.411 6.251 12 6.251Z"
      fill={props.fill}
    />
  </svg>
)

BankIcon.defaultProps = {
   width: 24,
   height: 24,
   fill: '#2563EB'
 }

export { BankIcon }
